export const ENTER_CODE = 13;

export function handleKey(e, code = ENTER_CODE) {
  return e.charCode === code;
}
